angular.module('mtic')
.service('DataCacheService', function (EventManager, $q, $log) {

  // vars
  var eventManager;
  var flag;
  var buffer;
  var store;
  var resolutions;

  // private methods
  var resetCache = function(){
    flag = {};
    buffer = {};
    store = {};
    resolutions = {};
  }
  var resolveVal = function(key, val){
    flag[key] = true;
    store[key] = val;
    if (resolutions[key]){
      _.each(resolutions[key], function(resolution){
        resolution(val);
      });
      resolutions[key] = [];
    }
  }
  var registerResolution = function(key, cb){
    if (!resolutions[key]){
      resolutions[key] = [];
    }
    resolutions[key].push(cb);
  }
  var fetchVal = function(key, fetcher, cb){
    //console.log('DataCacheService.fetchVal', key, 'flag:', flag[key], 'buffer:', buffer[key]);
    return $q(function(resolve, reject){
      $log.debug('[[CACHE SERVICE]] STARTED:', key)
          var done = function(data, error){
                if(!error){
                  $log.debug('[[CACHE SERVICE]] DONE (SUCCESS):', key, data)
                  if(cb) {
                        cb(data)
                  }
                  resolve(data)
                }else{
                  $log.warn('[[CACHE SERVICE]] DONE (FAIL):', key, error)
                  if(cb) {
                        cb(null, error)
                  }
                  reject(error)
                }
         }
          if (flag[key]){
           done(store[key], null);
          }
          else if(buffer[key]){
           registerResolution(key, done);
          }
          else{
           registerResolution(key, done);
           buffer[key] = true;
           try{
             var fetcherRes = fetcher(function(val){
               buffer[key] = false;
               resolveVal(key, val);
             })
             if(fetcherRes && fetcherRes.catch){//suport for error catching in promises
               fetcherRes.catch(function(error){
                 done(null,error);
               })
             }
           }catch(error){
             done(null,error);
           }
          }
   })
  }

  // init
  eventManager = new EventManager('DataCacheService');
  resetCache();
  eventManager.listen('logout', function(){
    resetCache();
  });

  // public methods
  return {
    fetch: function(params){
      if(params.reset) {
        this.flush(params.key, params.reset === 'hard')
      }
      return fetchVal(params.key, params.fetcher, params.action)
    },
    flush: function(key, hard){
      flag[key] = false;
      if (hard){
        store[key] = null;
      }
    }
  }

})
